<template>
	<!---Profile Clinic Wrap-->
	<section class="profile-clinic section_pad">
		<div class="row">
			<!--Layout-->
			<div class="layout">

				<!--Sidebar-->
				<aside class="sidebar layout__sidebar">

					<!--Sidebar Avatar-->
					<div class="sidebar__avatar-wrap">
						<user-avatar :data="user" :setClass="'sidebar__avatar'"></user-avatar>
					</div>
					<!--Sidebar Avatar End-->

					<!--Sidebar Menu-->
					<nav class="sidebar__menu">
						<ul class="sidebar__list">
							<li class="sidebar__list-item">
								<a href="#" class="sidebar__link"> - Клиника</a>
							</li>

							<li class="sidebar__list-item">
								<router-link :to="{name: 'Personal'}" class="sidebar__link">
									- Сотрудники
								</router-link>
							</li>

							<li class="sidebar__list-item">
								<router-link :to="{name: 'Patients'}" class="sidebar__link">
									- Пациенты
								</router-link>
							</li>

							<li class="sidebar__list-item">
								<router-link :to="{name: 'Profile', params: {profile: user._id}}" class="sidebar__link">
									- Профиль
								</router-link>
							</li>

							<li class="sidebar__list-item">
								<router-link :to="{name: 'ClinicVisits'}" class="sidebar__link">
									- Записи
								</router-link>
							</li>
						</ul>
					</nav>
					<!--Sidebar Menu End-->

				</aside>

				<!--Sidebar End-->
				<div class="layout__box">
					<router-view></router-view>
				</div>

			</div>
			<!--Layout End-->

		</div>
		<!--Row End-->

	</section>
	<!--Profile Clinic Wrap End-->

</template>

<script>
	export default {
		name: 'Clinic',
		computed: {
			user() {
				return this.$parent.user
			},
		},
	}
</script>



// WEBPACK FOOTER //
// Main.vue?14a81fbe